export default __webpack_public_path__ + "static/image9-59c4be01cee2959cc3fd6a48cd001124.png";